import { ErrorOutlineOutlinedIcon, Flex, Text } from '@shared/components';

export default function QuestionNotFoundOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        py: theme.spacing(4),
      })}
    >
      <ErrorOutlineOutlinedIcon color='error' sx={{ fontSize: '48px' }} />
      <Text variant='h5' color='textSecondary'>
        ไม่มีข้อสอบที่ตรงตามเงื่อนไข กรุณาลองใหม่อีกครั้ง
      </Text>
    </Flex>
  );
}
